<template>
  <v-app id="inspire">
    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app color="primary" dark>
      <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
        <v-img src="https://www.emaraplay.com/wp-content/uploads/2020/02/logo_emara3.png" width="200"/>
      </v-toolbar-title>
      <v-spacer />
      
      <v-menu bottom right max-width="150" offset-y>
        <template v-slot:activator="{ on }">
          <v-list-item class="ma-2" right v-on="on" max-width=200 style="max-width:200px">
            <v-list-item-content width="100">
              <v-list-item-title class="headline">{{ username }}</v-list-item-title>
              <v-list-item-subtitle>{{ balance }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </template>

        <v-list>
          <v-list-item style="flex-direction:column">
            <v-list-item-title @click="depositdialog = !depositdialog">Depósito</v-list-item-title>
            <v-list-item-title @click="$router.push({name: 'transactions'})">Transacciones</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn v-if="isLogged" icon @click="logout()">
        <v-icon>mdi-logout</v-icon>
      </v-btn>
      <v-btn v-if="!isLogged" icon @click="logindialog = !logindialog">
        <v-icon>mdi-login</v-icon>
      </v-btn>
      <v-btn v-if="!isLogged" icon @click="registerdialog = !registerdialog">
        <v-icon>mdi-account-plus</v-icon>
      </v-btn>
      <v-btn icon @click="$router.push('/')">
        <v-icon>mdi-home</v-icon>
      </v-btn>
    </v-app-bar>

    <v-content>
      <v-container>
        <router-view></router-view>
      </v-container>
    </v-content>

    <v-footer inset app>
      <span class="px-4">Emara Play &copy; {{ new Date().getFullYear() }}</span>
    </v-footer>

    <v-dialog v-model="logindialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Login</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="logindialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container class="fill-height" fluid center>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="8" md="4">
                <v-form>
                  <v-text-field label="Login" name="login" prepend-icon="mdi-account" type="text" v-model="userdata.username" />
                  <v-text-field id="password" label="Password" name="password" prepend-icon="mdi-lock" type="password" v-model="userdata.password" />
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="submitLogin()">Login</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="registerdialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Register</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="registerdialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container class="fill-height" fluid center>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="8" md="4">
                <v-form>
                  <v-text-field label="currency" name="currency" prepend-icon="mdi-money" type="text" v-model="userdata.currency" />
                  <v-text-field label="email" name="login" prepend-icon="mdi-account" type="text" v-model="userdata.email" />
                  <v-text-field label="username" name="login" prepend-icon="mdi-account" type="text" v-model="userdata.username" />
                  <v-text-field id="password" label="Password" name="password" prepend-icon="mdi-lock" type="password" v-model="userdata.password" />
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="submitRegister()">Register</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="depositdialog" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>Deposit</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="depositdialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container class="fill-height" fluid center>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="8" md="4">
                <v-form>
                  <v-text-field id="amount" label="Amount" name="amount" prepend-icon="mdi-money" type="number" v-model="userdata.amount" />
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="submitDeposit()">Deposit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbar">
      {{ snackbarText.statusText }}
      <v-btn color="pink" text @click="snackbar = false">
        Close
      </v-btn>
    </v-snackbar>
  </v-app>
</template>

<script>
  export default {
    name: 'App',
    created () {
      setTimeout(this.refreshBalance, 5000);
    },
    components: {
    },
    mounted(){
      this.$store.dispatch('getProviders');
      console.log('CREATED');
    },
    computed: {
      isLogged() {
        console.log(this.$store.state.userData);
        return this.$store.state.login.logged;
      },
      username() {
        if (this.$store.state.login.logged) {
          return this.$store.state.userData.username;
        } else {
          return '';
        }
      },
      balance() {
        if (this.$store.state.login.logged) {
          return this.$store.state.userData.balance;
        } else {
          return '';
        }
      },
      selectedGame() {
        return this.$store.state.selectedGame || {};
      },
      getUrl() {
        return 'https://wallet-uat.emaraplay.com/casino/viewer?operator=MON&token=' + this.token + '&gameid=' + this.selectedGame.code + '&mode=' + this.mode + '&lang=es&lobby=http://www.google.es';
      },
      token() {
        return this.$store.state.login.token;
      },
      mode() {
        return this.$store.state.login.logged ? 'real' : 'fun';
      },
      gamedialog() {
        return this.$store.state.selectedGame && this.$store.state.selectedGame.code;
      },
      snackbar() {
        return this.$store.state.error && this.$store.state.error.userLogin && this.$store.state.error.userLogin.statusText !== '';
      },
      snackbarText() {
        return this.snackbar ? this.$store.state.error.userLogin.statusText : '';
      }         
    },
    data: () => ({
      logindialog: null,
      registerdialog: null,
      leftdrawer: null,
      rightdrawer: null,
      depositdialog: null,
      items: [
        { icon: 'mdi-home', text: 'Home', route:"home" },
        { icon: 'mdi-cup', text: 'Fantasy', route:"fantasy" },
        { icon: 'mdi-slot-machine', text: 'Slots', route: 'slots' },
        { icon: 'mdi-gamepad-variant', text: 'Virtual Sports', route: 'virtual-sports' },
        { icon: 'mdi-card-playing-online', text: 'Live Casino', route: 'live-casino' },
        { icon: 'mdi-ticket', text: 'SportsBook', route: 'sportsbook' },
      ],
      userdata: {
        currency: 'EUR',
        name: '', 
        username: '',
        email: '',
        password: '',
        amount: 0
      },
    }),
    methods: {
      submitLogin(){
        this.$store.dispatch('userLogin', this.userdata);
        this.logindialog = !this.logindialog;
      },
      submitRegister() {
        this.$store.dispatch('userRegister', this.userdata);
        this.registerdialog = !this.registerdialog;
      },
      submitDeposit() {
        this.$store.dispatch('userDeposit', this.userdata);
        this.depositdialog = !this.depositdialog;
      },
      logout(){
        this.$store.dispatch('userLogout');
      },
      closeGame(){
        this.$store.dispatch('closeGame');
      },
      closeSnackbar() {
        this.$store.dispatch('clearError');
      },
      refreshBalance() {
        if (this.isLogged) {
          this.$store.dispatch('refreshBalance');
          console.log('LOGGED')
        }
        setTimeout(this.refreshBalance, 5000);
      }
    },
  }
</script>
